const TMDBID = {
    NETWORK: {
        NETFLIXID: 213,
        PRIMEVIDEOID: 1024,
        DISNEYPLUSID: 2739,
    },
    GENRE: {
        ACTION: 28,
        HORROR: 27,
        ROMANCE: 10749,
        COMEDY: 35,
    }
}

export default TMDBID;